var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cell is-col-span-1 is-flex",
      staticStyle: { position: "relative" },
      attrs: { inert: _vm.isSaving },
      on: { focusout: _vm.onComponentFocusOut },
    },
    [
      _vm.isSaving
        ? _c("div", { staticClass: "quote-item-saving-overlay" })
        : _vm._e(),
      _c("article", { staticClass: "box is-flex-grow-1 main-container" }, [
        _vm._m(0),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [
            _vm._v("Request for Quote Date"),
          ]),
          _c(
            "div",
            { staticClass: "control" },
            [
              _vm.readOnlyView
                ? _c("input", {
                    staticClass: "input is-static",
                    attrs: { readonly: "" },
                    domProps: {
                      value: _vm.$filters.formatDateLocale(
                        _vm.innerQuote.quoteDate,
                        _vm.$userInfo.locale
                      ),
                    },
                  })
                : _c("v-date-picker", {
                    attrs: {
                      "is-dark": _vm.$theme.isDark,
                      masks: _vm.formats,
                      attributes: _vm.attrs,
                      locale: _vm.$userInfo.locale,
                      timezone: _vm.$filters.getIanaTimezone(),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                { staticClass: "control has-icons-left" },
                                [
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        staticClass: "input",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Quote Date",
                                        },
                                        domProps: { value: inputValue },
                                      },
                                      inputEvents
                                    )
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "icon is-small is-left" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-calendar mdi-18px",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.innerQuoteDate,
                      callback: function ($$v) {
                        _vm.innerQuoteDate = $$v
                      },
                      expression: "innerQuoteDate",
                    },
                  }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c("div", { staticClass: "field column mr-0" }, [
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Inspection Booking"),
                  ]),
                  _vm.readOnlyView
                    ? _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateLocale(
                            _vm.innerValue.inspectionBookingDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      })
                    : _c("v-date-picker", {
                        ref: "datepicker",
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          mode: "dateTime",
                          "minute-increment": 5,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.innerInspectionBookingDate
                            ? {}
                            : _vm.modelConfig,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "field is-fullwidth" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "control has-icons-left" },
                                      [
                                        _c(
                                          "input",
                                          _vm._g(
                                            {
                                              staticClass: "input",
                                              attrs: {
                                                type: "text",
                                                placeholder:
                                                  "Inspection Start Date",
                                                disabled:
                                                  _vm.isRepx ||
                                                  _vm.innerQuote
                                                    .isArriveForInspection,
                                              },
                                              domProps: { value: inputValue },
                                            },
                                            inputEvents
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "icon is-small is-left",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-calendar mdi-18px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.innerInspectionBookingDate,
                          callback: function ($$v) {
                            _vm.innerInspectionBookingDate = $$v
                          },
                          expression: "innerInspectionBookingDate",
                        },
                      }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field column mr-0" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Booking Attended"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.innerQuote.isArriveForInspection ? "Yes" : "No")
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c("div", { staticClass: "field column mr-0" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Sent for Authority"),
              ]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _vm.readOnlyView
                    ? _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateLocale(
                            _vm.innerValue.sentForAuthorizationDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      })
                    : _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.innerSentForAuthorizationDate
                            ? {}
                            : _vm.modelConfig,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              type: "text",
                                              placeholder:
                                                "Sent for Assessment",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.innerSentForAuthorizationDate,
                          callback: function ($$v) {
                            _vm.innerSentForAuthorizationDate = $$v
                          },
                          expression: "innerSentForAuthorizationDate",
                        },
                      }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field column mr-0" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Authority Date")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _vm.readOnlyView
                    ? _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateLocale(
                            _vm.innerQuote.authorisedDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      })
                    : _vm._e(),
                  _c("v-date-picker", {
                    attrs: {
                      "is-dark": _vm.$theme.isDark,
                      masks: _vm.formats,
                      attributes: _vm.attrs,
                      locale: _vm.$userInfo.locale,
                      timezone: _vm.$filters.getIanaTimezone(),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "div",
                                { staticClass: "control has-icons-left" },
                                [
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        staticClass: "input",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Authority Date",
                                        },
                                        domProps: { value: inputValue },
                                      },
                                      inputEvents
                                    )
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "icon is-small is-left" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-calendar mdi-18px",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.innerAuthorityDate,
                      callback: function ($$v) {
                        _vm.innerAuthorityDate = $$v
                      },
                      expression: "innerAuthorityDate",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c("div", { staticClass: "field column mr-0" }, [
              _vm.innerQuote.isRepairBooked == null ||
              (_vm.innerQuote.isRepairBooked != null &&
                _vm.innerQuote.isRepairBooked)
                ? _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "label",
                          class: {
                            "is-disabled":
                              _vm.innerQuote.isRepairBooked == null,
                          },
                        },
                        [_vm._v(" Repair Booked Date ")]
                      ),
                      _vm.readOnlyView
                        ? _c("input", {
                            staticClass: "input is-static",
                            attrs: { readonly: "" },
                            domProps: {
                              value: _vm.$filters.formatDateLocale(
                                _vm.innerValue.repairBookedDate,
                                _vm.$userInfo.locale
                              ),
                            },
                          })
                        : _c("v-date-picker", {
                            ref: "datepicker",
                            staticClass: "is-fullwidth",
                            attrs: {
                              "is-dark": _vm.$theme.isDark,
                              mode: "dateTime",
                              "minute-increment": 5,
                              masks: _vm.formats,
                              attributes: _vm.attrs,
                              locale: _vm.$userInfo.locale,
                              "model-config": _vm.innerRepairBookedDate
                                ? {}
                                : _vm.modelConfig,
                              timezone: _vm.$filters.getIanaTimezone(),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ inputValue, inputEvents }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field has-addons" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "control is-expanded has-icons-left",
                                            },
                                            [
                                              _c(
                                                "input",
                                                _vm._g(
                                                  {
                                                    staticClass: "input",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Repair Booked Date",
                                                      disabled:
                                                        _vm.innerQuote
                                                          .isRepairBooked ==
                                                        null,
                                                    },
                                                    domProps: {
                                                      value: inputValue,
                                                    },
                                                  },
                                                  inputEvents
                                                )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "icon is-small is-left",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-calendar mdi-18px",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "control" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "button tooltip",
                                                  attrs: {
                                                    "data-tooltip":
                                                      "Reset dates",
                                                    disabled:
                                                      _vm.innerQuote
                                                        .isRepairBooked == null,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.clearRepairBookedDate()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "icon" },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "mdi mdi-close mdi-24px",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2965345974
                            ),
                            model: {
                              value: _vm.innerRepairBookedDate,
                              callback: function ($$v) {
                                _vm.innerRepairBookedDate = $$v
                              },
                              expression: "innerRepairBookedDate",
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.innerQuote.isRepairBooked != null &&
              !_vm.innerQuote.isRepairBooked
                ? _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Refuse Book Repair Reason"),
                    ]),
                    _c("div", { staticClass: "control is-expanded" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.innerQuote.refuseBookRepairReason,
                            expression: "innerQuote.refuseBookRepairReason",
                          },
                        ],
                        staticClass: "input is-fullwidth",
                        class: {
                          "is-invalid":
                            _vm.$v.entity.refuseBookRepairReason.$error,
                        },
                        domProps: {
                          value: _vm.innerQuote.refuseBookRepairReason,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.innerQuote,
                              "refuseBookRepairReason",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.$v.entity &&
                      !_vm.$v.entity.refuseBookRepairReason.required
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Refuse Book Repair Reason is required"),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "field column mr-0" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Is Repair Booked"),
              ]),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "pretty p-default p-round p-smooth" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerQuote.isRepairBooked,
                          expression: "innerQuote.isRepairBooked",
                        },
                      ],
                      attrs: {
                        id: "chk-pretty-is-repair-booked-yes",
                        name: "chk-pretty-is-repair-booked",
                        type: "radio",
                      },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.innerQuote.isRepairBooked, true),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.innerQuote,
                            "isRepairBooked",
                            true
                          )
                        },
                      },
                    }),
                    _vm._m(1),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "pretty p-default p-round p-smooth" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerQuote.isRepairBooked,
                          expression: "innerQuote.isRepairBooked",
                        },
                      ],
                      attrs: {
                        id: "chk-pretty-is-repair-booked-no",
                        name: "chk-pretty-is-repair-booked",
                        type: "radio",
                      },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.innerQuote.isRepairBooked, false),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.innerQuote,
                            "isRepairBooked",
                            false
                          )
                        },
                      },
                    }),
                    _vm._m(2),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c("div", { staticClass: "field column mr-0" }, [
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Estimated Start Date"),
                  ]),
                  _vm.readOnlyView || _vm.isRepairStartDateSynced
                    ? _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateTimeLocale(
                            _vm.innerQuote.jobStart,
                            _vm.$userInfo.locale
                          ),
                        },
                      })
                    : _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          mode: "dateTime",
                          "minute-increment": 5,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.innerJobStartDate
                            ? {}
                            : _vm.modelConfig,
                          "max-date": _vm.innerJobEndDate,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "field is-fullwidth" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "control has-icons-left" },
                                      [
                                        _c(
                                          "input",
                                          _vm._g(
                                            {
                                              directives: [
                                                {
                                                  name: "tippy",
                                                  rawName: "v-tippy",
                                                  value: {
                                                    theme: "danger",
                                                    enabled:
                                                      _vm.$v.entity.jobStart
                                                        .$error,
                                                  },
                                                  expression:
                                                    "{ theme: 'danger', enabled: $v.entity.jobStart.$error }",
                                                },
                                              ],
                                              staticClass: "input",
                                              class: {
                                                "is-invalid":
                                                  _vm.$v.entity.jobStart.$error,
                                              },
                                              attrs: {
                                                type: "text",
                                                placeholder: "Job Start Date",
                                                content:
                                                  _vm.ormEstimateStartEndValidationText,
                                              },
                                              domProps: { value: inputValue },
                                            },
                                            inputEvents
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "icon is-small is-left",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-calendar mdi-18px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.innerJobStartDate,
                          callback: function ($$v) {
                            _vm.innerJobStartDate = $$v
                          },
                          expression: "innerJobStartDate",
                        },
                      }),
                  _vm.isRepx
                    ? _c("span", { staticClass: "help is-info" }, [
                        _vm._v(
                          "Once the Start Date is synced, it cannot be updated."
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "field column mr-0" }, [
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Estimated End Date"),
                  ]),
                  _vm.readOnlyView
                    ? _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateLocale(
                            _vm.innerQuote.jobEnd,
                            _vm.$userInfo.locale
                          ),
                        },
                      })
                    : _c("v-date-picker", {
                        staticClass: "is-fullwidth",
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          mode: "dateTime",
                          "minute-increment": 5,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.innerJobEndDate
                            ? {}
                            : _vm.modelConfig,
                          "min-date": _vm.innerJobStartDate,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field has-addons" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "control is-expanded has-icons-left",
                                    },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  theme: "danger",
                                                  enabled:
                                                    _vm.$v.entity.jobEnd.$error,
                                                },
                                                expression:
                                                  "{ theme: 'danger', enabled: $v.entity.jobEnd.$error }",
                                              },
                                            ],
                                            staticClass: "input",
                                            class: {
                                              "is-invalid":
                                                _vm.$v.entity.jobEnd.$error,
                                            },
                                            attrs: {
                                              type: "text",
                                              placeholder: "Job End Date",
                                              content:
                                                _vm.ormEstimateStartEndValidationText,
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "button tooltip",
                                        attrs: {
                                          "data-tooltip": "Reset dates",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.resetJobStartEnd()
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "icon" }, [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-close mdi-24px",
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.innerJobEndDate,
                          callback: function ($$v) {
                            _vm.innerJobEndDate = $$v
                          },
                          expression: "innerJobEndDate",
                        },
                      }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c(
              "div",
              { staticClass: "field column mr-0" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Vehicle Arrived"),
                ]),
                _vm.readOnlyView
                  ? _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateLocale(
                          _vm.innerValue.arrivedForRepairDate,
                          _vm.$userInfo.locale
                        ),
                      },
                    })
                  : _c("v-date-picker", {
                      ref: "datepicker",
                      staticClass: "is-fullwidth",
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        mode: "dateTime",
                        "minute-increment": 5,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        "model-config": _vm.innerArrivedForRepairDate
                          ? {}
                          : _vm.modelConfig,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field has-addons" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "control is-expanded has-icons-left",
                                  },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "Arrive for Repair Date",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button tooltip",
                                      attrs: { "data-tooltip": "Reset dates" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearArrivedForRepairDate()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "icon" }, [
                                        _c("i", {
                                          staticClass: "mdi mdi-close mdi-24px",
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.innerArrivedForRepairDate,
                        callback: function ($$v) {
                          _vm.innerArrivedForRepairDate = $$v
                        },
                        expression: "innerArrivedForRepairDate",
                      },
                    }),
              ],
              1
            ),
            _c("div", { staticClass: "field column mr-0" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Vehicle On Site"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "pretty p-switch p-fill" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: !!_vm.isArrived },
                    on: { change: _vm.isArrivedOnChange },
                  }),
                  _c("div", { staticClass: "state p-primary" }, [
                    _c("label", [_vm._v(_vm._s(_vm.isArrived ? "Yes" : "No"))]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c(
              "div",
              { staticClass: "field column mr-0" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Job Start Date"),
                ]),
                _vm.readOnlyView
                  ? _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateLocale(
                          _vm.innerValue.actualJobStart,
                          _vm.$userInfo.locale
                        ),
                      },
                    })
                  : _c("v-date-picker", {
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        mode: "dateTime",
                        "minute-increment": 5,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        "model-config": _vm.innerActualJobStart
                          ? {}
                          : _vm.modelConfig,
                        "max-date": _vm.jobCompletionDateTime,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field is-fullwidth" }, [
                                _c(
                                  "div",
                                  { staticClass: "control has-icons-left" },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Job Start",
                                            readonly: "",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.innerActualJobStart,
                        callback: function ($$v) {
                          _vm.innerActualJobStart = $$v
                        },
                        expression: "innerActualJobStart",
                      },
                    }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "field column mr-0" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Job Completed Date"),
                ]),
                _vm.readOnlyView
                  ? _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateLocale(
                          _vm.innerValue.actualJobEnd,
                          _vm.$userInfo.locale
                        ),
                      },
                    })
                  : _c("v-date-picker", {
                      staticClass: "is-fullwidth",
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        mode: "dateTime",
                        "minute-increment": 5,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        "model-config": _vm.innerActualJobEnd
                          ? {}
                          : _vm.modelConfig,
                        "min-date": _vm.innerActualJobStart,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field has-addons" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "control is-expanded has-icons-left",
                                  },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Job Completion",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button tooltip",
                                      attrs: { "data-tooltip": "Reset dates" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.resetActualJobStartAndEnd()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "icon" }, [
                                        _c("i", {
                                          staticClass: "mdi mdi-close mdi-24px",
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.innerActualJobEnd,
                        callback: function ($$v) {
                          _vm.innerActualJobEnd = $$v
                        },
                        expression: "innerActualJobEnd",
                      },
                    }),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "field is-horizontal" }, [
          _c("div", { staticClass: "field-body columns" }, [
            _c(
              "div",
              { staticClass: "field column mr-0" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Vehicle Picked Up"),
                ]),
                _vm.readOnlyView
                  ? _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateLocale(
                          _vm.innerValue.vehicleDepartedDate,
                          _vm.$userInfo.locale
                        ),
                      },
                    })
                  : _c("v-date-picker", {
                      ref: "datepickerVehicleDeparted",
                      staticClass: "is-fullwidth",
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        mode: "dateTime",
                        "minute-increment": 5,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        "model-config": _vm.innerVehicleDepartedDate
                          ? {}
                          : _vm.modelConfig,
                        "min-date": _vm.innerValue.arrivedForRepairDate,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field has-addons" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "control is-expanded has-icons-left",
                                  },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "Vehicle Departed Date",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button tooltip",
                                      attrs: { "data-tooltip": "Reset dates" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearVehicleDepartedDate()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "icon" }, [
                                        _c("i", {
                                          staticClass: "mdi mdi-close mdi-24px",
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.innerVehicleDepartedDate,
                        callback: function ($$v) {
                          _vm.innerVehicleDepartedDate = $$v
                        },
                        expression: "innerVehicleDepartedDate",
                      },
                    }),
              ],
              1
            ),
            _c("div", { staticClass: "field column mr-0" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Vehicle Departed"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "pretty p-switch p-fill" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: !!_vm.isDeparted },
                    on: { change: _vm.isDepartedOnChange },
                  }),
                  _c("div", { staticClass: "state p-primary" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.isDeparted ? "Yes" : "No")),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm.isRepairLateReasonActive
        ? _c(
            "late-reason-modal",
            {
              attrs: {
                active: _vm.isRepairLateReasonActive,
                "show-icon": true,
                "cancel-disabled": false,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRepairLateReasonActive = $event
                },
                saveContinue: function ($event) {
                  return _vm.handleRepairLateReasonClose()
                },
                close: function ($event) {
                  return _vm.handleRepairLateReasonClose()
                },
              },
              model: {
                value: _vm.innerValue,
                callback: function ($$v) {
                  _vm.innerValue = $$v
                },
                expression: "innerValue",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Late Reason"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns mb-0" }, [
      _c("div", { staticClass: "column is-flex is-align-items-center" }, [
        _c("span", { staticClass: "mso mso-24px mr-2" }, [
          _vm._v("calendar_clock"),
        ]),
        _c("p", { staticClass: "title pl-1" }, [_vm._v("Key Dates")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Yes")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("No")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }